import type {
	EffectiveStatus,
	RenderableContentArtifact,
} from '@/hooks/useContentArtifacts';

import type { Action } from '../../../../bridge/types/action.ts';
import {
	isDigitalAd,
	isEmail,
	isPost,
} from '../../../../bridge/types/artifact.ts';
import type { ProcessStatus } from '../../../../bridge/types/process.ts';

import { DigitalAdAsset } from './DigitalAdAsset';
import { EmailAsset } from './EmailAsset';
import { PostAsset } from './PostAsset';

interface ContentAssetProps {
	artifact: RenderableContentArtifact;
	action?: Action;
	effectiveStatus: EffectiveStatus;
	processStatus?: ProcessStatus;
	onClick?: () => void;
	isSelectable?: boolean;
	isSelected?: boolean;
	onToggleSelect?: () => void;
}

export const ContentAsset = ({
	artifact,
	action,
	effectiveStatus,
	processStatus,
	onClick,
	isSelectable,
	isSelected,
	onToggleSelect,
}: ContentAssetProps) => {
	if (isPost(artifact)) {
		return (
			<PostAsset
				post={artifact}
				effectiveStatus={effectiveStatus}
				processStatus={processStatus}
				onClick={onClick}
				isSelectable={isSelectable}
				isSelected={isSelected}
				onToggleSelect={onToggleSelect}
			/>
		);
	}
	if (isDigitalAd(artifact)) {
		return (
			<DigitalAdAsset
				artifact={artifact}
				effectiveStatus={effectiveStatus}
				onClick={onClick}
				isSelectable={isSelectable}
				isSelected={isSelected}
				onToggleSelect={onToggleSelect}
			/>
		);
	}
	if (isEmail(artifact)) {
		return (
			<EmailAsset
				artifact={artifact}
				action={action}
				effectiveStatus={effectiveStatus}
				onClick={onClick}
				isSelectable={isSelectable}
				isSelected={isSelected}
				onToggleSelect={onToggleSelect}
			/>
		);
	}
	return null;
};
